import { LineaVenta } from "../models/LineaVentaModel";
import { UserPayload } from "../models/SiteModel";
import { parseDecimalValue } from "../utils/NumberParser";

const URLAPI = process.env.REACT_APP_BASE_URL;

const getProductoPrecio = (producto: any) =>
  parseDecimalValue(producto.CONTADO ?? producto.contado ?? producto.Contado ?? producto.precio ?? producto.Precio ?? producto.precioContado ?? producto.PrecioContado ?? 0);

export type GuardarVentaOptions = {
  numeroPv?: number;
  idCaja?: number;
  cliente?: string;
  total?: number;
  formaPago?: string;
  descuento?: number;
  recargo?: number;
  observacion?: string;
  ldp?: string;
  numeroMesa?: string;
  origen?: string;
  notificarWindowsForms?: boolean;
};

const mapLineaVentaToPayload = (linea: LineaVenta) => ({
  Id_Lineaventa: 0,
  Id_Venta: 0,
  Id_Producto: (linea.producto as any).IDPRODUCTO ?? (linea.producto as any).idProducto ?? (linea.producto as any).IdProducto,
  Cod_Prod: (linea.producto as any).CODIGO ?? (linea.producto as any).codigo ?? (linea.producto as any).Codigo,
  Producto: (linea.producto as any).PRODUCTO ?? (linea.producto as any).producto ?? (linea.producto as any).Producto,
  Cantidad: linea.cantidad,
  Precio_Unitario: getProductoPrecio(linea.producto),
  Precio_Real: getProductoPrecio(linea.producto),
  Notas: linea.notas || ""
});

export async function fetchGuardarVenta(user: UserPayload,
    idCliente: number, idLocal: number, lineaventa:LineaVenta[], options?: GuardarVentaOptions | string
) {
    const token = user.token;
    const payload = lineaventa.map(mapLineaVentaToPayload);
    const normalizedOptions: GuardarVentaOptions = typeof options === "string"
      ? { numeroMesa: options }
      : options ?? {};
    const postData = JSON.stringify({
        IdLocal: idLocal,
        IdCliente: idCliente,
        NumeroPv: normalizedOptions.numeroPv,
        IdCaja: normalizedOptions.idCaja,
        Cliente: normalizedOptions.cliente,
        Total: normalizedOptions.total,
        FormaPago: normalizedOptions.formaPago,
        Descuento: normalizedOptions.descuento,
        Recargo: normalizedOptions.recargo,
        Observacion: normalizedOptions.observacion,
        Ldp: normalizedOptions.ldp,
        NumeroMesa: normalizedOptions.numeroMesa,
        Mesa: normalizedOptions.numeroMesa,
        Origen: normalizedOptions.origen,
        NotificarWindowsForms: normalizedOptions.notificarWindowsForms,
        LineaVenta: payload
    });
    const response = await fetch(
      `${URLAPI}/Venta/GuardarVenta`,
      {
        method: "POST", headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: postData
      }
    );
  
    const data = await response.json();
    return data;
  }

export async function fetchGetMesaAbierta(user: UserPayload, idLocal: number, numeroMesa: string) {
  const token = user.token;
  const response = await fetch(
    `${URLAPI}/Venta/GetMesaAbierta?idLocal=${idLocal}&numeroMesa=${encodeURIComponent(numeroMesa)}`,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        IdLocal: idLocal,
        NumeroMesa: numeroMesa,
        Mesa: numeroMesa
      })
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
}
